/**
 * Toast - Notification display component
 *
 * Renders toasts from ToastContext at the bottom-center of the workspace panel.
 * Slides up + fades in on mount, fades out on dismiss.
 *
 * @module @humanizer/studio/components/ui/Toast
 */

import { useToast } from '../../contexts/ToastContext';
import '../../styles/toast.css';

export function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="status" aria-live="polite">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`toast toast--${toast.type}${toast.dismissing ? ' toast--dismissing' : ''}`}
          role="alert"
        >
          <span className="toast__message">{toast.message}</span>
          {toast.action && (
            <button
              className="toast__action"
              onClick={() => {
                toast.action!.onClick();
                dismissToast(toast.id);
              }}
            >
              {toast.action.label}
            </button>
          )}
          <button
            className="toast__close"
            onClick={() => dismissToast(toast.id)}
            aria-label="Dismiss"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
